// extracted by mini-css-extract-plugin
module.exports = {"show-off":"GatherKnowledge_show-off__1-FI4"};